import { useEventCallback } from './useEventCallback';

export function useCombinedEventCallbacks<
  T extends (...args: Array<any>) => void
>(...callbacks: Array<T>): (...args: Parameters<T>) => void {
  return useEventCallback((...args) => {
    for (const callback of callbacks) {
      callback(...args);
    }
  });
}
